<ng-container *ngIf="sparkline">
    <app-sparkline [sparklineConfig]="sparkline" [marker]="marker" [height]="sparkelineHeight"
        [width]="sparkelineWidth" [showOnlyMarkerPoint]="true"></app-sparkline>
</ng-container>
<ng-container *ngIf="!sparkline">
    <div>No Data Found</div>
</ng-container>